/* eslint-disable */
import { combineEpics, ofType, StateObservable } from 'redux-observable';
import { of, from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import { fetchAdsSuccess, fetchAdsFailure } from './action';
import { FETCH_ADS_REQUEST } from './actionType';

export const fetchAdsEpic = (
  action$,
  state$,
  { advertisementInteractor: { fetchAds }, utils: { arrayOfObjectsToObject } },
) =>
  action$.pipe(
    ofType(FETCH_ADS_REQUEST),
    mergeMap(() => {
      return from(fetchAds()).pipe(
        mergeMap(response => {
          const ads = arrayOfObjectsToObject(response, 'id');

          return [fetchAdsSuccess(ads)];
        }),
        catchError(error => {
          return of(fetchAdsFailure(error));
        }),
      );
    }),
  );

export default combineEpics(fetchAdsEpic);
